(function () {
  'use strict';

  var bodyClassEnabled = 'mn-mobile-discover-enabled';
  var bodyClassOpen = 'mn-mobile-discover-open';

  function getFocusable(container) {
    return Array.prototype.slice.call(
      container.querySelectorAll(
        'a[href], button:not([disabled]), details > summary, [tabindex]:not([tabindex="-1"])'
      )
    ).filter(function (item) {
      return !item.hidden && item.offsetParent !== null;
    });
  }

  function selectTab(root, tabName, moveFocus) {
    var tabs = root.querySelectorAll('[data-mnd-tab]');
    var panels = root.querySelectorAll('[data-mnd-panel]');

    tabs.forEach(function (tab) {
      var selected = tab.getAttribute('data-mnd-tab') === tabName;
      tab.setAttribute('aria-selected', selected ? 'true' : 'false');
      tab.setAttribute('tabindex', selected ? '0' : '-1');
      if (selected && moveFocus) tab.focus();
    });

    panels.forEach(function (panel) {
      panel.hidden = panel.getAttribute('data-mnd-panel') !== tabName;
    });
  }

  function setOpen(root, open) {
    var trigger = root.querySelector('[data-mnd-open]');
    var sheet = root.querySelector('[data-mnd-sheet]');
    var close = root.querySelector('[data-mnd-close]');

    root.classList.toggle('is-open', open);
    trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    sheet.setAttribute('aria-hidden', open ? 'false' : 'true');
    if (open) {
      sheet.removeAttribute('inert');
    } else {
      sheet.setAttribute('inert', '');
    }
    document.body.classList.toggle(bodyClassOpen, open);

    if (open) {
      window.requestAnimationFrame(function () {
        close.focus();
      });
    } else if (document.activeElement && root.contains(document.activeElement)) {
      trigger.focus();
    }
  }

  function initialiseRoot(root) {
    if (!root || root.getAttribute('data-mnd-initialised') === 'true') return;

    /*
     * mn-header is sticky and is translated when scrolling. Moving this fixed UI
     * to <body> prevents the bottom navigation from moving with that header.
     */
    if (root.parentNode !== document.body) document.body.appendChild(root);

    root.setAttribute('data-mnd-initialised', 'true');
    document.body.classList.add(bodyClassEnabled);
    selectTab(root, 'categories', false);
  }

  function initialiseAll() {
    document.querySelectorAll('[data-mn-mobile-discover]').forEach(initialiseRoot);
  }

  if (!window.__MN_MOBILE_DISCOVER_EVENTS__) {
    window.__MN_MOBILE_DISCOVER_EVENTS__ = true;

    document.addEventListener('click', function (event) {
      var openButton = event.target.closest('[data-mnd-open]');
      var closeButton = event.target.closest('[data-mnd-close], [data-mnd-backdrop]');
      var tabButton = event.target.closest('[data-mnd-tab]');

      if (openButton) {
        var openRoot = openButton.closest('[data-mn-mobile-discover]');
        setOpen(openRoot, !openRoot.classList.contains('is-open'));
        return;
      }

      if (closeButton) {
        setOpen(closeButton.closest('[data-mn-mobile-discover]'), false);
        return;
      }

      if (tabButton) {
        selectTab(
          tabButton.closest('[data-mn-mobile-discover]'),
          tabButton.getAttribute('data-mnd-tab'),
          false
        );
      }
    });

    document.addEventListener('keydown', function (event) {
      var root = document.querySelector('[data-mn-mobile-discover].is-open');
      if (!root) return;

      if (event.key === 'Escape') {
        event.preventDefault();
        setOpen(root, false);
        return;
      }

      var activeTab = event.target.closest && event.target.closest('[data-mnd-tab]');
      if (activeTab && (event.key === 'ArrowLeft' || event.key === 'ArrowRight')) {
        event.preventDefault();
        selectTab(
          root,
          activeTab.getAttribute('data-mnd-tab') === 'categories' ? 'brands' : 'categories',
          true
        );
        return;
      }

      if (event.key === 'Tab') {
        var sheet = root.querySelector('[data-mnd-sheet]');
        var focusable = getFocusable(sheet);
        if (!focusable.length) return;
        var first = focusable[0];
        var last = focusable[focusable.length - 1];

        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }
    });

    document.addEventListener('shopify:section:load', initialiseAll);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialiseAll);
  } else {
    initialiseAll();
  }
})();
